<template>
<div class="container">
  <page-title title="Dashboard" row-class="mb-0"/>
  <div class="row small mt-0 pt-0 mb-3 text-secondary">
    <div class="col col-auto mx-auto">
      <span v-if="timeAgo">As of: {{ timeAgo }}</span>
      <span class="ps-2"><a href="#" @click="refresh()" v-b-tooltip.hover title="Refresh"><i class="fas fa-sync fa-lg"></i></a></span>
    </div>
  </div>
  
  <div class="row">
    <div class="col-auto">
      <period-selector @periodUpdated="onPeriodUpdated" default-period="TODAY" />
    </div>
    <input-select v-model="accountId" group-class="col-auto ms-auto" v-if="accounts && accounts.length > 1">
      <option value="">All Accounts</option>
      <option v-for="acct in accounts" :key="acct.accountId" :value="acct.accountId">{{acct.accountName}}</option>
    </input-select>
  </div>
  
  <div class="row mt-5 table-responsive">
    <table class="col-auto table table-bordered small">
      <thead class="table-dark">
        <tr>
          <th rowspan="2" class="align-middle">Channel</th>
          <th colspan="2" class="text-center">Failed/Cancelled</th>
          <th colspan="2" class="text-center">Pending/In Process</th>
          <th colspan="3" class="text-center">Completed Pay-Ins</th>
          <th colspan="2" class="text-center">Completed Pay-Outs</th>
        </tr>
        <tr>
          <th width="7%" class="text-center small bg-secondary">Count</th>
          <th width="10%" class="text-center small bg-secondary">Amount</th>
          <th width="7%" class="text-center small bg-secondary">Count</th>
          <th width="10%" class="text-center small bg-secondary">Amount</th>
          <th width="7%" class="text-center small bg-secondary">Count</th>
          <th width="12%" class="text-center small bg-secondary">Requested</th>
          <th width="12%" class="text-center small bg-secondary">Processed</th>
          <th width="7%" class="text-center small bg-secondary">Count</th>
          <th width="12%" class="text-center small bg-secondary">Processed</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="summary.channelSummList && summary.channelSummList.length > 0">
        <tr v-for="csumm in summary.channelSummList" :key="csumm.channelCode">
          <td>{{csumm.channelCode}}</td>
          <td class="text-center small">{{csumm.totalFailedCancelled.count}}</td>
          <td class="text-end small"><display-amount :value="csumm.totalFailedCancelled.requestedAmount" :currency="csumm.currency"/></td>
          <td class="text-center small">{{csumm.totalPendingInProcess.count}}</td>
          <td class="text-end small"><display-amount :value="csumm.totalPendingInProcess.requestedAmount" :currency="csumm.currency"/></td>
          <td class="text-center payin-col">{{csumm.completedPayins.count}}</td>
          <td class="text-end payin-col"><display-amount :value="csumm.completedPayins.requestedAmount" :currency="csumm.currency"/></td>
          <td class="text-end payin-col"><display-amount :value="csumm.completedPayins.processedAmount" :currency="csumm.currency"/></td>
          <td class="text-center payout-col">{{csumm.completedPayouts.count}}</td>
          <td class="text-end payout-col"><display-amount :value="csumm.completedPayouts.processedAmount" :currency="csumm.currency"/></td>
        </tr>
        </template>
        <template v-else>
        <tr>
          <td colspan="10" class="text-center fw-bold text-warning py-3">No transactions for the period</td>
        </tr>
        </template>
      </tbody>
    </table>
  </div>

  <wait-modal :loading="isLoading"/>
</div>
</template>

<script>
import moment from 'moment'
import PeriodSelector from '../components/PeriodSelector.vue'
import WaitModal from '../components/WaitModal.vue'
import HelpersMixin from '../utils/HelpersMixin.js'
export default {
  name: 'DashboardView',
  mixins: [HelpersMixin],
  components: { PeriodSelector, WaitModal },
  data () {
    return {
      startDate: '',
      endDate: '',
      summary: {},
      accounts: [],
      accountId: '',
      poller: null,
      refreshTimer: null,
      lastRefresh: new Date(),
      timeAgo: null
    }
  },
  mounted () {
    this.getAccounts()
    this.poller = setInterval(this.refresh, 300000)
    this.refreshTimer = setInterval(this.setTimeAgo, 60000)
    this.$watch('accountId', this.getSummary)
  },
  beforeDestroy () {
    if (this.poller) {
      clearInterval(this.poller)
    }
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  },
  methods: {
    getSummary: function () {
      this.isLoading = true
      this.axios.post('/mx/summarybychannel', {startDate: this.startDate, endDate: this.endDate, accountId: this.accountId})
      .then(response => {
        this.summary = response.data
        this.isLoading = false
        this.setTimeAgo()
      })
      .catch(error => this.handleError(error))
    },
    getAccounts: function () {
      this.axios.get('/mx/accounts')
      .then(response => {
        this.accounts = response.data
      })
      .catch(error => this.handleError(error))
    },
    onPeriodUpdated: function (eventData) {
      this.startDate = eventData.startDate
      this.endDate = eventData.endDate
      this.getSummary()
    },
    setTimeAgo: function () {
      this.timeAgo = moment(this.lastRefresh).fromNow()
    },
    refresh: function () {
      this.getSummary()
      this.lastRefresh = new Date()
      this.setTimeAgo()
    }
  }
}
</script>

<style scoped>
.payin-col { background-color: #ccffcc; font-weight: bold; }
.payout-col { background-color: #ffe6e6; font-weight: bold; }
</style>
